export class Accordion {
	constructor(elements, singleAccordionMode = false) {
		this.accordion = elements.map((element) => {
			return {
				element: element,
				btn: element.querySelector('.js-accordion-btn'),
				content: element.querySelector('.js-accordion-content'),
				isActive: false,
			}
		})
		this.singleAccordionMode = singleAccordionMode
		this.init()
	}

	init() {
		this.accordion.forEach((accordion) => {
			accordion.btn.setAttribute('tabindex', '0')
			accordion.btn.addEventListener('click', () => this.toggle(accordion))
			accordion.btn.addEventListener('keydown', (event) => this.handleKeyDown(event, accordion))
		})
	}

	closeAllAccordion() {
		this.accordion.forEach((accordion) => {
			if (accordion.isActive) {
				this.toggle(accordion)
			}
		})
	}

	toggle(accordion) {
		accordion.content.style.height = `${accordion.content.scrollHeight}px`

		if (!accordion.isActive) {
			// open
			if (this.singleAccordionMode) {
        this.closeAllAccordion();
      }

			accordion.element.classList.add('js-accordion-active')
			accordion.content.addEventListener('transitionend', () => {
				// condition for prevent multiple openings
				if (accordion.content.style.offsetHeight) {
					accordion.content.style.height = 'auto'
				}
			}, { once: true })
		} else {
			// close
			accordion.element.classList.remove('js-accordion-active')
			setTimeout(() => {
				accordion.content.removeAttribute('style')
			}, 0)

		}
		accordion.isActive = !accordion.isActive
	}

	handleKeyDown(event, accordion) {
		if (event.isComposing || event.keyCode === 32 || event.keyCode === 13) {
			this.toggle(accordion)
		}
	}
}
